<svg id="startTime" *ngIf="startLocation">
    <rect width="100%" height="100%" fill="red"></rect>
</svg>
<svg id="currentTime">
    <rect width="100%" height="100%" fill="blue"></rect>
</svg>
<svg id="side-ruler-svg" istag="svg" height="100" width="20">
</svg>
